import React, { useEffect, useMemo, useState } from "react"
import { Col, Container, NavLink, Row, NavItem, Nav } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import Spinners from "components/Shared/Spinners"

import {
  getCardBatches,
  getCardsAsPerJobs,
  getIssuedCandidates,
  getNotIssuedCandidates,
} from "store/actions/cardsAction"
import { toggleActiveTab, setPayload } from "store/reducers/cardReducer"
import { usePermissions } from "hooks"
import Datatable from "./component/Datatable"
import UploadNationalIdModal from "./component/UploadNationalIdModal"
import {
  getJobTitlesList,
  getStationShiftDropdownList,
} from "store/actions/commonAction"

import ExportsDatatable from "./component/ExportsDataTable"
import CandidatesDataTable from "./component/CandidatesDataTable"

const navItems = [
  {
    name: "Job Titles",
    id: "Jobs",
  },
  {
    name: "Requested Cards",
    id: "Exports",
  },
  {
    name: "Issued",
    id: "issued",
  },
  {
    name: "Not issued",
    id: "Not issued",
  },
]

const IdCards = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const {
    loading,
    isLoading,
    totalPages,
    totalCount,
    currentPage,
    payload,
    batches,
    activeTab,
    jobsCards,
    candidates,
  } = useSelector(state => state.Card)
  const { work_shifts, stations, mealTypes, jobTitlesList } = useSelector(
    state => state.Common
  )

  const { permissions, showAll } = usePermissions("id_card")

  const [trigger, setTrigger] = useState(false)
  const [addEditModal, setAddEditModal] = useState(false)

  const formtedJobTitles = useMemo(() => {
    if (!jobTitlesList) return []

    return jobTitlesList.map(item => ({
      id: item.id,
      name: language === "en" ? item.name : item.name_ar,
      candidates_for_cards: 0,
      candidates_for_cards_remaining: 0,
    }))
  }, [jobTitlesList, language])

  useEffect(() => {
    getAllData()
  }, [trigger, activeTab])

  useEffect(() => {
    dispatch(getStationShiftDropdownList())
  }, [])

  useEffect(() => {
    dispatch(getJobTitlesList())
  }, [])

  const getAllData = () => {
    if (activeTab === "Exports") {
      dispatch(getCardBatches(payload))
    } else if (activeTab === "Jobs") {
      dispatch(getCardsAsPerJobs(payload))
    } else if (activeTab === "Not issued") {
      dispatch(getNotIssuedCandidates(payload))
    } else {
      dispatch(getIssuedCandidates(payload))
    }
  }

  const onPageChange = page => {
    dispatch(setPayload({ page_number: page }))
    setTrigger(!trigger)
  }

  if (loading) return <Spinners />

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="d-flex mb-4 justify-content-between align-items-center">
                <h4 className="card-title">{t("ID Cards")}</h4>
                <div className="d-flex gap-3 align-items-center justify-content-center">
                  {(showAll || permissions.includes("can_generate")) && (
                    <div>
                      <button
                        className="main_btn"
                        onClick={() => {
                          setAddEditModal(true)
                        }}
                      >
                        {t("Generate Id Cards")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </Col>
            <Col xs="12">
              <Nav tabs className="one_line_parent mb-3">
                {navItems.map(nav => (
                  <NavItem key={nav.id}>
                    <NavLink
                      className={activeTab === nav.id ? "active" : ""}
                      onClick={() => dispatch(toggleActiveTab(nav.id))}
                    >
                      {t(nav.name)}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Col>
            <Col xs="12">
              {activeTab === "Jobs" ? (
                <Datatable
                  data={jobsCards}
                  currentPage={currentPage}
                  loading={loading}
                  onPageChange={onPageChange}
                  totalCount={totalCount}
                  totalPages={totalPages}
                  showAll={showAll}
                  permissions={permissions}
                  isLoading={isLoading}
                  work_shifts={work_shifts}
                  stations={stations}
                  mealTypes={mealTypes}
                  trigger={() => setTrigger(!trigger)}
                  payload={payload}
                />
              ) : activeTab === "Exports" ? (
                <ExportsDatatable
                  data={batches}
                  currentPage={currentPage}
                  loading={loading}
                  onPageChange={onPageChange}
                  totalCount={totalCount}
                  totalPages={totalPages}
                  trigger={() => setTrigger(!trigger)}
                  payload={payload}
                />
              ) : (
                <CandidatesDataTable
                  data={candidates}
                  currentPage={currentPage}
                  loading={loading}
                  onPageChange={onPageChange}
                  totalCount={totalCount}
                  totalPages={totalPages}
                  trigger={() => setTrigger(!trigger)}
                  payload={payload}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
      {addEditModal && (
        <UploadNationalIdModal
          isOpen={addEditModal}
          toggle={() => setAddEditModal(false)}
          trigger={() => setTrigger(!trigger)}
        />
      )}
    </>
  )
}

export default IdCards
